import { Link } from 'react-router-dom';

import { Alert } from '../../../components/Alert';
import { Breadcrumbs } from '../../../components/Breadcrumbs';
import { EmptyState } from '../../../components/EmptyState';
import { PageHeader } from '../../../components/PageHeader';
import { PageSpinner } from '../../../components/PageSpinner';
import { Timeline } from '../../../components/Timeline';
import { customerDashboardApi } from '../../../features/customer-dashboard/customer-dashboard.api';
import { useSessionQuery as useQuery } from '../../../hooks/useSessionQuery';
import { toDisplayMessage } from '../../../lib/error-message';
import { paths } from '../../../routes/paths';
import styles from '../AppPages.module.css';

export function CustomerTimelinePage(): React.JSX.Element {
  const timeline = useQuery({
    queryKey: ['customer', 'timeline'],
    queryFn: () => customerDashboardApi.getTimeline(),
  });

  const events = timeline.data?.items ?? [];

  return (
    <div className={styles.page}>
      <PageHeader
        title="Timeline"
        subtitle="Key milestones in your solar repayment journey."
        breadcrumbs={
          <Breadcrumbs
            items={[
              { label: 'Overview', to: paths.dashboard },
              { label: 'Your account', to: paths.dashboard },
              { label: 'Timeline' },
            ]}
          />
        }
        actions={<Link to={paths.dashboard}>Back to overview</Link>}
      />

      <section className={styles.card} aria-labelledby="timeline-heading">
        <h2 className={styles.cardTitle} id="timeline-heading">
          Activity
        </h2>

        {timeline.isPending && <PageSpinner label="Loading timeline" />}
        {timeline.isError && <Alert tone="error">{toDisplayMessage(timeline.error)}</Alert>}

        {timeline.isSuccess && events.length === 0 && (
          <EmptyState title="No timeline events yet">
            Events appear here as you progress through onboarding, contracts and payments.
          </EmptyState>
        )}

        {timeline.isSuccess && events.length > 0 && <Timeline events={events} />}
      </section>
    </div>
  );
}
